import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Input from "../general/input";

const CtaModule = ({ index, name }) => {
  return (
    <div className="box-body">
      <div className="row">
        <div className="col-md-12">
          <div className="fomr-group">
            <div className="input-group">
              <Input
                className="form-control"
                placeholder="Text"
                name={`${name}.[${index}].data.text`}
                showClearInputButton={false}
                debounceTime={0}
              />
              <Input
                className="form-control"
                placeholder="Url"
                name={`${name}.[${index}].data.url`}
                showClearInputButton={false}
                debounceTime={0}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CtaModule.propTypes = {
  index: PropTypes.number,
  name: PropTypes.string,
};

export default connect()(CtaModule);
